/**
 * Mẫu khai nghiệp vụ cho nguồn dùng chế độ kế toán doanh nghiệp Việt Nam.
 *
 * ── NGUỒN: TOÀN VĂN CÔNG BÁO, KHÔNG PHẢI BÀI TÓM TẮT ──────────────────────
 * Thông tư 99/2025/TT-BTC ngày 27/10/2025, đăng Công báo số 1563–1582 ngày
 * 16/11/2025. Mọi mã số và trích dẫn dưới đây lấy từ bản PDF Công báo
 * (congbaocdn.chinhphu.vn), không lấy từ trang tin trung gian.
 *
 * Việc ấy có lý do đo được: hai trang tin trung gian đọc trong cùng phiên đưa
 * ra hai câu trái ngược về mã 440 — một bên bảo "không xuất hiện trong mẫu
 * mới", một bên bảo vẫn còn. Toàn văn cho thấy bên thứ hai đúng. Dựng bản
 * khai từ bài tóm tắt là đúng lớp sai mà cả bộ đệm và bộ canh cổng sinh ra để
 * chặn, chỉ khác là lần này người sai là chúng ta.
 *
 * ── VÌ SAO NÚT NÀY CHỈ ĐỔ CHỮ VÀO Ô, KHÔNG LƯU ────────────────────────────
 * Điều 11 khoản 2 cho doanh nghiệp "sửa đổi, bổ sung về tên, số hiệu, kết cấu
 * và nội dung phản ánh của các tài khoản kế toán". Nên "3xx là nợ phải trả"
 * là quy ước phổ biến, không phải sự thật áp cho mọi nguồn.
 *
 * Đã gặp một ca lệch thật: bảng cân đối của `public_lbm` ghi `400 = 410`,
 * trong khi mẫu B01-DN của TT99 đánh số vốn chủ sở hữu từ 411 đến 420.
 */

/** Hiện trong nhãn nút. Đổi khi khảo lại theo một bản Công báo khác. */
export const MAU_KE_TOAN_VN_CAN_CU = 'TT 99/2025/TT-BTC';

/**
 * ⚠️ MÃ SỐ DƯỚI ĐÂY LÀ NGUYÊN VĂN MẪU B01-DN — đừng "sửa cho gọn".
 * Tổng tài sản là **280**, không phải 270; TT200 cũ dùng 270 và đó đúng là
 * chỗ một bản nháp trước của tệp này đã chép sai.
 */
export const MAU_GHI_CHU_KE_TOAN_VN = `Nguồn này dùng chế độ kế toán doanh nghiệp Việt Nam.
Căn cứ: Thông tư 99/2025/TT-BTC, hiệu lực 01/01/2026, áp dụng cho năm tài chính
bắt đầu từ hoặc sau 01/01/2026, thay Thông tư 200/2014/TT-BTC (Điều 31).

BÁO CÁO TÌNH HÌNH TÀI CHÍNH — Mẫu số B01-DN
Từ năm tài chính 2026, mẫu này thay cho "Bảng cân đối kế toán". Bảng dữ liệu
trong ERP thường vẫn mang tên cũ; hỏi "bảng cân đối" hay "tình hình tài chính"
là hỏi cùng một báo cáo.
- Mã 280 = TỔNG CỘNG TÀI SẢN. TT200 cũ dùng mã 270.
- Mã 300 = C - NỢ PHẢI TRẢ
- Mã 400 = D - VỐN CHỦ SỞ HỮU
- Mã 440 = TỔNG CỘNG NGUỒN VỐN

⚠️ 400 VÀ 440 LÀ HAI CHỈ TIÊU KHÁC NHAU. Hỏi "nguồn vốn" hay "tổng nguồn vốn"
thì lấy mã 440. Mã 400 chỉ là phần vốn chủ sở hữu, thiếu mất nợ phải trả —
lấy nhầm sẽ ra một con số nhỏ hơn nhiều mà vẫn trông hợp lý.
Quan hệ số học giữa chúng: 440 bằng 300 cộng 400, và bằng 280.

MỖI DÒNG LÀ MỘT SỐ DƯ, KHÔNG PHẢI MỘT PHÁT SINH
Lọc lấy ĐÚNG MỘT dòng — một mã chỉ tiêu, một kỳ gần nhất trong khoảng hỏi —
rồi đọc thẳng giá trị. KHÔNG dùng SUM trên cột số dư: gộp nhiều kỳ ra gấp số
kỳ, gộp nhiều mã chỉ tiêu là đếm hai lần vì 440 đã bao gồm 300 và 400.

ĐỪNG DỰNG LẠI TỪ SỔ CÁI
Điều 11 khoản 2 cho doanh nghiệp sửa tên và số hiệu tài khoản, nhưng ràng buộc
việc sửa ấy "không được làm thay đổi hoặc ảnh hưởng đến các chỉ tiêu, thông tin
trình bày trên Báo cáo tài chính". Nghĩa là MÃ CHỈ TIÊU BÁO CÁO ỔN ĐỊNH trong
khi HỆ THỐNG TÀI KHOẢN THÌ KHÔNG — đó là lý do pháp lý để đọc báo cáo thay vì
cộng lại từ tài khoản.
Đo trên một bản chạy thật: phép cộng theo lớp tài khoản ra thiếu 73,5 tỷ trên
1.159 tỷ, toàn bộ nằm ở nợ phải trả, vì báo cáo tách số dư Nợ/Có của công nợ
theo TỪNG ĐỐI TƯỢNG còn phép cộng theo lớp thì bù trừ chúng trong nội bộ một
tài khoản.

NHÓM TÀI KHOẢN (Phụ lục II) — chỉ dùng khi buộc phải đọc sổ cái
Chia theo NHÓM, không đánh số "loại 1…9" như TT200: tài sản (111…), nợ phải
trả (331…), vốn chủ sở hữu (411…), doanh thu (511…), chi phí SXKD (6xx), thu
nhập khác (711…), chi phí khác (811…, 821…), xác định kết quả (911).
Số dư nguồn vốn tính bằng SUM(phát sinh Có − phát sinh Nợ).
⚠️ Điều 11 khoản 2 cho sửa số hiệu tài khoản, nên kiểm lại dải mã THẬT của
doanh nghiệp này trước khi dựa vào quy ước trên.`;

/**
 * Thuật ngữ đi kèm. NGẮN có chủ đích: từ điển đi vào lời nhắc của mọi lượt
 * hỏi, và phần dài đã nằm ở ghi chú — chép lại là trả tiền hai lần cho cùng
 * một câu.
 */
export const MAU_THUAT_NGU_KE_TOAN_VN: { term: string; meaning: string }[] = [
  {
    term: 'nguồn vốn',
    meaning:
      'Mã 440 của Báo cáo tình hình tài chính (B01-DN, TT 99/2025/TT-BTC) = nợ phải ' +
      'trả (300) + vốn chủ sở hữu (400). Là SỐ DƯ tại một thời điểm, không phải phát ' +
      'sinh trong kỳ.',
  },
  {
    term: 'tổng tài sản',
    meaning:
      'Mã 280 của Báo cáo tình hình tài chính (280 = 100 + 200). TT200 cũ dùng mã ' +
      '270. Bằng mã 440.',
  },
  {
    term: 'bảng cân đối kế toán',
    meaning:
      'Từ năm tài chính 2026 gọi là "Báo cáo tình hình tài chính" (mẫu B01-DN, ' +
      'TT 99/2025/TT-BTC). Hỏi bằng tên nào cũng là hỏi cùng một báo cáo.',
  },
];
